import { RULE_TYPES } from './types';

export const POINTS_RANGES = [
    { key: '<3000', label: '<3000', filter: (points: number) => points < 3000 },
    { key: '3000~6000', label: '3000~6000', filter: (points: number) => points >= 3000 && points < 6000 },
    { key: '6000~10000', label: '6000~10000', filter: (points: number) => points >= 6000 && points < 10000 },
    { key: '>10000', label: '>10000', filter: (points: number) => points >= 10000 },
] as const;

export type PointsRangeKey = (typeof POINTS_RANGES)[number]['key'];

export const ERROR_CODE_MAP: Record<string, string> = {
    '2418': 'no_enough_points',
    '2422': 'stay_too_long',
    '2423': 'exceeded_counts',
    '2424': 'stay_too_long',
    '2426': 'no_stock_tip',
    '2429': 'no_stock_tip',
    '2475': 'only_plus_member',
    '2476': 'only_member',
};

export const RESET_RULES_ERROR_CODES = ['2475', '2476'];

export const SUCCESS_BTN_TEXT_MAP: Record<string, string> = {
    [RULE_TYPES.COUPONS]: 'store',
    [RULE_TYPES.THIRD_COUPONS]: 'spend_now',
};

export const SPECIAL_COPY_DESC_LOCALES = ['br', 'mx', 'ph'];

export const SPECIAL_SUCCESS_MSG_RULE_TYPES = [RULE_TYPES.FREE_PRODUCTS, RULE_TYPES.THIRD_COUPONS];

export const SHOW_AMOUNT_RULE_TYPES = [RULE_TYPES.COUPONS, RULE_TYPES.GIFT_CARD];

export const DEFAULT_ACTIVE_TAB = 'COUPONS_RULES';
